import { Injectable } from '@angular/core';
import { AsyncValidator, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { PromocodeService } from '../../../../shared/services/promocode.service';

@Injectable({ providedIn: 'root' })
export class PromotionCodeValidator implements AsyncValidator {
  constructor(private promocodeService: PromocodeService) {}

  validate(ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    // if the input is empty or on init, no value
    // is sent through the pipe so we have to manually send an observable of null back.
    // no promocode, no server side check, no error ;^)
    if (ctrl.value === '') {
      return of(null);
    }
    // does not work with empty promocode field on startup.
    return this.promocodeService.currentState.pipe(
      first(null),
      map(state => {
        if (state) {
          return null;
        }
        return { promocodeInvalid: true };
      })
    );
  }
}
